/** @format */

import PropTypes from "prop-types";
import { formatCurrency } from "../../../utility/currencyUtils";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
	Avatar,
	Box,
	Grid,
	List,
	ListItem,
	ListItemAvatar,
	ListItemText,
	Menu,
	MenuItem,
	Typography,
} from "@mui/material";
import SkeletonSchedule from "./skeletonSchedule";
import { CardWrapper } from "./styles";
import { useState } from "react";
import { colors } from "../../../utility/types/constant";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import CalendarViewMonthIcon from "@mui/icons-material/CalendarViewMonth";

interface PayOutCardProps {
	isLoading: boolean;
	expectedPayOuts: number;
	currency?: string;
}

const PayOutScheduleCard = (props: PayOutCardProps) => {
	const { isLoading, expectedPayOuts, currency = "usd" } = props;

	const theme = useTheme();

	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<>
			{isLoading ? (
				<SkeletonSchedule />
			) : (
				<CardWrapper border={false} content={false}>
					<Box sx={{ p: 2 }}>
						<Grid container direction="column">
							<Grid item>
								<Grid container justifyContent="space-between">
									<Grid item>
										<List sx={{ py: 0 }}>
											<ListItem
												alignItems="center"
												disableGutters
												sx={{ py: 0 }}>
												<ListItemAvatar>
													<Avatar
														variant="rounded"
														sx={{
															...theme.typography,
															...theme.typography,
															backgroundColor: colors.mainSecondary,
															color: colors.white,
														}}>
														<CalendarViewMonthIcon fontSize="inherit" />
													</Avatar>
												</ListItemAvatar>
												<ListItemText
													sx={{
														py: 0,
														mt: 0.45,
														mb: 0.45,
													}}
													primary={
														<Typography
															sx={{
																color: colors.secondary,
																fontFamily: "'Montserrat', sans-serif",
																fontWeight: 990,
															}}
															variant="h4">
															{formatCurrency(expectedPayOuts, currency)}
														</Typography>
													}
													secondary={
														<Typography
															variant="subtitle2"
															sx={{
																color: colors.secondary,
																mt: 0.5,
																fontFamily: "'Montserrat', sans-serif",
																fontWeight: 990,
															}}>
															Up Coming Pay Out
														</Typography>
													}
												/>
											</ListItem>
										</List>
									</Grid>

									{/* <Grid item>
										<Avatar
											variant="rounded"
											sx={{
												...theme.typography,
												...theme.typography,
												backgroundColor: colors.mainSecondary,
												color: (theme.palette.secondary as any)[200],
												zIndex: 1,
											}}
											aria-controls="menu-earning-card"
											aria-haspopup="true"
											onClick={handleClick}>
											<MoreHorizIcon fontSize="inherit" />
										</Avatar>

										<Menu
											id="menu-earning-card"
											anchorEl={anchorEl}
											keepMounted
											open={Boolean(anchorEl)}
											onClose={handleClose}
											variant="selectedMenu"
											anchorOrigin={{
												vertical: "bottom",
												horizontal: "right",
											}}
											transformOrigin={{
												vertical: "top",
												horizontal: "right",
											}}>
											<MenuItem onClick={handleClose}>
												<CalendarViewMonthIcon sx={{ mr: 1.75 }} /> View
												Schedule
											</MenuItem>
										</Menu>
									</Grid> */}
								</Grid>
							</Grid>
						</Grid>
					</Box>
				</CardWrapper>
			)}
		</>
	);
};

PayOutScheduleCard.propTypes = {
	isLoading: PropTypes.bool,
	expectedPayOuts: PropTypes.number,
};

export default PayOutScheduleCard;
